import { db } from '../firebase'
import _ from 'lodash'

const state = {
  brands: {},
}

const getters = {
  brands: state => state.brands,
}

const actions = {
  async fetchBrands(context) {
    const snap = await db.collection('brands').get()
    const brands = _.reduce(snap.docs, (acc, doc) => ({
      ...acc,
      [doc.id]: doc.data()
    }), {})
    context.commit('setBrands', brands)
  }
}

const mutations = {
  setBrands(state, brands) {
    state.brands = brands
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
